export default [
  {path: '/', redirect: '/login'},
  {path: '/login', meta: { permissions: 'common' }, component: () => import('@/views/Login.vue')},
  {
    path: '/home-page',
    component: () => import('@/views/HomePage.vue'),
    children: [
      {
        path: 'call-for-submissions',
        name: '征集活动',
        meta: { permissions: 'callForSubmissions', pageName: '征集活动管理', color: '#2A82E4'},
        component: () => import('@/views/page/CallForSubmissionsPage/Index.vue'),
      },
      {
        path: 'design-reworked-info',
        name: '设计再造资料',
        meta: { permissions: 'designReworkedInfo', pageName: '作品资料库', color: '#4BCEC5'},
        component: () => import('@/views/page/DesignReworkedInfoPage.vue'),
      },
      {
        path: 'system-manage',
        name: '系统管理',
        meta: { permissions: 'systemManage', pageName: '系统管理', color: '#4BCEC5'},
        component: () => import('@/views/page/SystemManagePage.vue'),
      },
    ],
  },
  {path: '/user-design-application',  name: '设计再造-报名申请', meta: { permissions: 'common' }, component: () => import('@/views/userPage/DesignReworkedApplication.vue')},
  {path: '/user-awards-collecting-application', name: '奖项征集-报名申请', meta: { permissions: 'common' }, component: () => import('@/views/userPage/AwardsCollectingApplication.vue')},
  {
    path: '/solicitation-page',
    name: '奖项征集-工作台',
    meta: { permissions: 'solicitationPage', pageName: '天津站奖项申报明细', color: '#4BCEC5'},
    component: () => import('@/views/workPage/SolicitationPage.vue'),
  },
]
